export enum TipoCustoKitFabricadoEnum {
    CustoCompra = 1,
    CustoMedio = 2,
}
